import {
  Box,
  Button,
  Collapse,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { FindInPageOutlined, KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { ReactNode, useCallback, useEffect, useMemo, useState } from "react";
import InputQuantidade from "src/framework/components/forms/inputs/InputQuantidade";
import { apiNoLoading, IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import theme from "src/theme/light";
import { Layout } from "../_layout"
import { ListagemItem, ProjetoCalcular, ResultadoCalculos } from "../../types";
import { validacaoValorServicoMinimo } from "../../utils/validarValorServicoMinimo";
import { PermissionUtil } from "src/framework/commons/PermissionUtil";
import { ProjetosProvider } from "src/providers/ProjetosProvider";
import { ServicoInformationModal } from "../../containers/ServicoInformationModal";
import { formatarComponentesCalcular } from "../../utils/formatarComponentesCalcular";
import { showEstruturasRemovidasAlert } from "../../utils/showEstruturasRemovidasAlert";
import { JustificativaValorServico } from "../../containers/InputsSection/containers/InputJustificativaValorServico";
import { exibeJustificativaValorServico$, modalComponentesDetalhesData$ } from "src/store/vendas/projetos/store";
import { ORDEM_GRUPO_CATEGORIAS, PROPOSTA_OPTIONS, VALOR_MULTIPLO_CABO } from "../../constants";
import { mostrarAvisoServicoRemovido } from "../../utils/mostrarAvisoServicoRemovido";
import { MENSAGEM_QUANTIDADE_CABOS_INVALIDA } from "src/constants";
import { useObservable } from "src/framework/store/storeUtil";
import { notifierStore } from "src/framework/store/NotifierStore";
import { CategoriaComponente, ID_CABO, ID_STRING_BOX, TGrupoCategoria } from "src/components/componentes/types";
import { DecimalUtil } from "src/framework/commons/DecimalUtils";
import { HIBRIDO_ERROR_MESSAGES, oldEstruturasHibrido$, useProjetosHibridoStore } from "src/store/vendas/projetos/hibrido/hibrido.store";
import { ResumoProjeto } from "./resumoProjeto";
import { TipoPropostaInput } from "./tipoProposta";
import { ValorServicoInput } from "./valorServico";
import { elSemEstrutura, ModalEditarEstruturas } from "./modalEditarEstruturas";
import { FormProjetoHibridoType } from "src/store/vendas/projetos/hibrido/hibrido.types";
import { ProjetosHibridoProvider } from "src/providers/ProjetosHibridoProvider";
import { calcularPotenciaEquipamentosHibrido } from "../../utils/calcularPotenciaEquipamentosHibrido";
import { calcularAcessorios } from "../utils/calcularAcessorios";
import { buscarEstruturasPorModulo } from "../utils/buscarEstruturasPorModulo";
import { categorias_componentes$ } from "src/store/global.store";
import { SolucaoMobile } from "./SolucaoMobile";

export const ACESSORIOS_MANTIDOS_EDICAO = [ID_CABO, ID_STRING_BOX];

const ProdutoCell = ({ children }: { children: ReactNode }) => {
  return (
    <TableCell align='left'>
      {children}
    </TableCell>
  )
}

const CodigoCell = ({ children }: { children: ReactNode }) => {
  return (
    <TableCell style={{ width: "126px" }} align='left'>
      {children}
    </TableCell>
  )
}

const QuantidadeCell = ({ children }: { children: ReactNode }) => {
  return (
    <TableCell style={{ width: "220px" }} align='center'>
      {children}
    </TableCell>
  )
}

const EmptyCell = ({ children }: { children?: ReactNode }) => {
  return (
    <TableCell style={{ width: "200px" }}  align='right'>
      {children}
    </TableCell>
  )
}

const DadosTecnicosCell = ({ componente }: { componente: { componente_id: number | null | undefined } }) => {
  return (
    <TableCell style={{ width: "200px" }} align='center'>
      <Box display={"flex"} alignItems="center" justifyContent={"center"}>
        <IconButton
          onClick={e => {
            e.stopPropagation();
            if (componente?.componente_id) {
              modalComponentesDetalhesData$.next(componente.componente_id)
            }
          }}
          size="large">
            <FindInPageOutlined htmlColor="black" />
        </IconButton>
      </Box>
    </TableCell>
  );
}

const useStyles = makeStyles({
  warningText: {
    color: theme.palette.warning.main,
    fontWeight: 600,
  },
  moduleTitle: {
    fontWeight: 600,
  },
  restoreButton: {
    backgroundColor: theme.palette.warning.dark,
    color: theme.palette.getContrastText(theme.palette.warning.dark),
    '&:hover': {
      backgroundColor: theme.palette.warning.dark,
    }
  },
  restoreButtonConfirm: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.getContrastText(theme.palette.error.main),
    '&:hover': {
      backgroundColor: theme.palette.error.main,
    }
  },
  tableHeaderRow: {
    height: 75,
    backgroundColor: "#0000000D",
    cursor: 'pointer'
  },
  collapseContainer: {
    marginBottom: 20,
  },
})

interface SolucaoProps {
  onClickNext: () => void
  onClickBack: () => void
}

let timerCalcular: NodeJS.Timeout

const projetosProvider = new ProjetosProvider();
const projetosHibridoProvider = new ProjetosHibridoProvider();

export const Solucao = ({ onClickBack, onClickNext }: SolucaoProps) => {
  const classes = useStyles();
  const permissoes = PermissionUtil.getPermissions();

  const [modalEditarEstruturasOpen, setModalEditarEstruturasOpen] = useState(false)
  const [collapseOpened, setCollapseOpened] = useState(true)
  const [calculando, setCalculando] = useState(false)
  
  const projetosHibridoState = useProjetosHibridoStore(store => store.state.data)
  const projetosHibridoStoreValidationState = useProjetosHibridoStore(store => store.state.validations)
  const projetosHibridoActions = useProjetosHibridoStore(store => store.actions)
  const categoriasComponentes = useObservable(categorias_componentes$);
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const onChangeQuantidade = useCallback((componente_id: number,value: number, tipo_componente: "acessorios" | "estruturas") => {
    switch (tipo_componente) {
      case "acessorios":
        const newAcessorios = projetosHibridoState.acessorios.map(item => {
          if (item.componente_id === componente_id) {
            return { ...item, quantidade: value }
          }
          return item;
        })
        projetosHibridoActions.changeValue({ acessorios: newAcessorios })
        break;
      case "estruturas":
        const newEstruturas = projetosHibridoState.estruturas_calculadas.map(item => {
          if (item.componente_id === componente_id) {
            return { ...item, quantidade: value }
          }
          return item;
        })
        projetosHibridoActions.changeValue({ estruturas_calculadas: newEstruturas })
        break;
    }
  }, [projetosHibridoState.acessorios, projetosHibridoState.estruturas_calculadas])

  useEffect(()=>{
    if ((projetosHibridoState.isEdit || projetosHibridoState.clonar_projeto) && Number(projetosHibridoState.valor_servico || 0) > 0 && !projetosHibridoState.revenda?.segmentos_servico?.includes(projetosHibridoState.segmento?.includes("on") ? "on" : "off")) {
      projetosHibridoActions.changeValue({
        valor_servico: 0,
        valor_servico_pis_cofins: 0,
        servico: null,
        justificativa_valor_servico: null,
        tipo_proposta: PROPOSTA_OPTIONS.find(item => item.value === 'gerador-sem-instalacao')
      })
      
      mostrarAvisoServicoRemovido()
    }
  },[projetosHibridoState.clonar_projeto, projetosHibridoState.isEdit, projetosHibridoState.revenda?.segmentos_servico, projetosHibridoState.segmento, projetosHibridoState.valor_servico])

  useEffect(()=>{
    if (projetosHibridoState.recebe_servico === false || !projetosHibridoState.revenda) {
      projetosHibridoActions.changeValue({
        valor_servico: 0,
        valor_servico_pis_cofins: 0,
        servico: null,
        justificativa_valor_servico: null,
        tipo_proposta: PROPOSTA_OPTIONS.find(item => item.value === 'gerador-sem-instalacao')
      })
    }
  },[projetosHibridoState.recebe_servico, projetosHibridoState.revenda])

  const servicoObrigatorio = useMemo(()=>{
    return projetosHibridoState.tipo_proposta?.value === 'gerador-com-instalacao'
  },[projetosHibridoState.tipo_proposta?.value])

  const calcular = useCallback(async()=>{
    const getValorServico = () => {
      if (!projetosHibridoState.recebe_servico) return 0;
      if (projetosHibridoState.tipo_proposta?.value === 'gerador-sem-instalacao') return 0;
      return Number(projetosHibridoState.valor_servico || 0)
    }

    const moduloSelecionado = projetosHibridoState.modulo_selecionado || null;

    const componentes = [];

    if (moduloSelecionado) {
      componentes.push(...formatarComponentesCalcular([moduloSelecionado]));
    }

    if (projetosHibridoState.solucao_calculada.baterias.length > 0) {
      componentes.push(...formatarComponentesCalcular(projetosHibridoState.solucao_calculada.baterias));
    }

    if (projetosHibridoState.solucao_calculada.inversores.length > 0) {
      componentes.push(...formatarComponentesCalcular(projetosHibridoState.solucao_calculada.inversores));
    }

    if (projetosHibridoState.estruturas_calculadas.length > 0) {
      componentes.push(...formatarComponentesCalcular(projetosHibridoState.estruturas_calculadas))
    }

    if (projetosHibridoState.acessorios.length > 0) {
      componentes.push(...formatarComponentesCalcular(projetosHibridoState.acessorios))
    }

    const componentesFiltrados = componentes.filter(c => c.quantidade > 0)

    const recalcular = projetosProvider.confereRecalcular(componentesFiltrados, {
      recalcular: projetosHibridoState.recalcular,
      alterou_segmento: false,
      estado_id: projetosHibridoState.estado?.id || '',
      old_estado_id: projetosHibridoState.old_estado_id,
      old_componentes_edicao: projetosHibridoState.old_componentes_edicao,
    });

    const payload: ProjetoCalcular = {
      componentes: componentesFiltrados,
      estado_id: projetosHibridoState.estado?.id || '',
      servicos: {
        valor_margem_produtos: 0,
        tipo: getValorServico() ? 'revenda' : null,
        valor: getValorServico(),
      },
      regioes: projetosHibridoState.regioes || [],
      segmento: projetosHibridoState.segmento,
      projeto_id: projetosHibridoState.clonar_projeto ? undefined : (projetosHibridoState.id || undefined),
      distribuidor_id: projetosHibridoState.distribuidor?.id || undefined,
      revenda_id: projetosHibridoState.revenda?.id || undefined,
      recalcular: recalcular,
    }

    const responseCalcular: IDataResponse<ResultadoCalculos> = await projetosProvider.calcular(payload, true)

    if (responseCalcular.statusCode !== STATUS_CODE.OK) {
      // Limpa valores calculados anteriormente, caso ocorra algum erro no cálculo.
      projetosHibridoActions.changeValue({ valor_servico_pis_cofins: 0, resultado_calculos: null })
      return;
    }

    projetosHibridoActions.changeValue({ valor_servico_pis_cofins: responseCalcular?.data?.servicos?.valor_com_pis_cofins || 0, resultado_calculos: responseCalcular.data })
  },[projetosHibridoState.acessorios, projetosHibridoState.clonar_projeto, projetosHibridoState.distribuidor?.id, projetosHibridoState.estado?.id, projetosHibridoState.estruturas_calculadas, projetosHibridoState.id, projetosHibridoState.modulo_selecionado, projetosHibridoState.old_componentes_edicao, projetosHibridoState.old_estado_id, projetosHibridoState.recalcular, projetosHibridoState.recebe_servico, projetosHibridoState.regioes, projetosHibridoState.revenda?.id, projetosHibridoState.segmento, projetosHibridoState.solucao_calculada.baterias, projetosHibridoState.solucao_calculada.inversores, projetosHibridoState.tipo_proposta?.value, projetosHibridoState.valor_servico])

  useEffect(()=>{
    clearTimeout(timerCalcular)
    setCalculando(true)
    timerCalcular = setTimeout(()=>{
      calcular().finally(() => setCalculando(false))
    }, 200)
  }, [calcular])

  const comparaEstruturas = (antiga: ListagemItem[], atual: ListagemItem[])=>{  
    if (antiga?.length !== atual?.length) return false;
      return antiga.every(itemAntigo => {
        const itemAtual = atual.find(a => a.componente_id === itemAntigo.componente_id);
        return itemAtual?.quantidade === itemAntigo?.quantidade;
      });
  }

  const temPermissaoCodigoComponente = useMemo(()=>{
    return PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_DETALHE_VISUALIZAR_CODIGO_COMPONENTE, permissoes)
},[permissoes])

  const onChangeModulo = useCallback(async (moduloId: number )=>{
    const moduloSelecionado = projetosHibridoState.modulos.find(item => item.componente_id === moduloId)
    const alterouModulo = moduloId !== projetosHibridoState.modulo_selecionado?.componente_id;
    const estrutura_selecionada = projetosHibridoState.fileiras?.[0]?.tipo_estrutura || null

    if (moduloSelecionado) {
      const qtdModulosResult = await projetosProvider.buscarQuantidadeDeModulos(moduloSelecionado.componente_id, projetosHibridoState.potencia_desejada_kw, projetosHibridoState.segmento, apiNoLoading)

      if (qtdModulosResult.statusCode !== STATUS_CODE.OK) {
        notifierStore.setNotifier({
            content: qtdModulosResult.message,
            onClose: () => notifierStore.setOpen(false),
            timeOut: 4000,
            title: "Atenção"
        })

        notifierStore.setOpen(true)
        return;
      }

      let qtdModulos = qtdModulosResult.data?.quantidade || 0;
      let alterouQtdModulos = Number(projetosHibridoState.modulo_selecionado?.quantidade || 0) !== qtdModulos;

      const savePayload: Partial<FormProjetoHibridoType> = {
        modulo_selecionado: {  ...moduloSelecionado, quantidade: qtdModulos },
      }

      let limparEstrutura = false;
      // // let acessorios: ListagemItem[] = [];
      if (alterouModulo) {
        const potenciaModulosEmWatts = savePayload.modulo_selecionado ? (savePayload.modulo_selecionado.quantidade * savePayload.modulo_selecionado.potencia) : 0
        const potenciaModulosEmKiloWatts = potenciaModulosEmWatts ? DecimalUtil.toFixed(potenciaModulosEmWatts / 1000, 2) : 0
        const valorMinimoServicoResult = await projetosProvider.calcularValorMinimoServico(potenciaModulosEmKiloWatts, apiNoLoading)
        if (valorMinimoServicoResult.statusCode !== STATUS_CODE.OK) {
          notifierStore.setNotifier({
            content: valorMinimoServicoResult.message || "Erro ao calcular valor mínimo de serviço.",
            onClose: () => notifierStore.setOpen(false),
            timeOut: 4000,
            title: "Atenção"
          })

          notifierStore.setOpen(true)
          return;
        }
        
        Object.assign(savePayload, { valor_minimo_servico: valorMinimoServicoResult.data?.valor_minimo_servico || 0 })

        const solucaoCalculadaResponse = await projetosHibridoProvider.calcularSolucao({
          regioes: projetosHibridoState.regioes,
          tensao_saida: projetosHibridoState.tensao_saida?.id || 0,
          tipo_conexao: projetosHibridoState.tipo_ligacao?.id || 0,
          tipo_bateria: projetosHibridoState.tipo_bateria?.id || null,
          taxa_descarga: projetosHibridoState.taxa_descarga?.id || null,
          potencia_desejada: projetosHibridoState.potencia_desejada_kw,
          carga_equipamentos: projetosHibridoState.total_carga_equipamentos_kw,
          potencia_equipamentos: calcularPotenciaEquipamentosHibrido(projetosHibridoState.cargas_prioritarias || []).total_kva,
          quantidade_modulos: savePayload.modulo_selecionado?.quantidade || 0,
          modulo_id: moduloSelecionado?.componente_id || null,
        })

        if (solucaoCalculadaResponse.statusCode !== STATUS_CODE.OK) {
          notifierStore.setNotifier({
            content: solucaoCalculadaResponse.message,
            onClose: () => notifierStore.setOpen(false),
            timeOut: 4000,
            title: "Atenção"
          })

          notifierStore.setOpen(true)
          return;
        }

        if (solucaoCalculadaResponse.data) {
          projetosHibridoActions.addSolucaoCalculada(solucaoCalculadaResponse.data)
        }

        const acessoriosResponse = await calcularAcessorios({
          moduloId: moduloSelecionado?.componente_id || 0,
          quantidade_modulos: qtdModulos,
          regioes: projetosHibridoState.regioes,
          inversores: solucaoCalculadaResponse.data?.inversores || [],
          projetoFiname: moduloSelecionado?.finame || false,
        })

        if (acessoriosResponse.statusCode !== STATUS_CODE.OK) {
          return;
        }

        const acessoriosOriginais = projetosHibridoState.acessorios ?? [];
        const acessoriosCalculados = acessoriosResponse?.data ?? [];

        const novosAcessorios = acessoriosCalculados.map((itemCalculado) => {
          if (ACESSORIOS_MANTIDOS_EDICAO.includes(itemCalculado.categoria_componentes_id)) {
            const itemOriginal = acessoriosOriginais.find(
              (item) => item.componente_id === itemCalculado.componente_id
            );

            if (itemOriginal) {
              return itemOriginal;
            }
          }
          return itemCalculado;
        });

        // acessorios = acessoriosResponse.data;

        const estruturasResponse = await buscarEstruturasPorModulo({
          moduloId: moduloSelecionado.componente_id,
          potencia: DecimalUtil.toFixed((Number(savePayload?.modulo_selecionado?.quantidade || 0) * Number(savePayload?.modulo_selecionado?.potencia || 0)) / 1000, 2),
          regioesId: projetosHibridoState.regioes,
        })

        Object.assign(savePayload, { 
          acessorios: novosAcessorios,
          todas_estruturas: estruturasResponse.todos || [],
          estruturas_ativas: estruturasResponse.ativos || [],
          estruturas_retrato: estruturasResponse.retrato || [],
          estruturas_paisagem: estruturasResponse.paisagem || [],
        })

        if (projetosHibridoState.fileiras.length === 1) {
          const posicaoModulo = projetosHibridoState.fileiras[0].posicao_modulo?.value;
          const estruturas = posicaoModulo === 'retrato' ? estruturasResponse.retrato : estruturasResponse.paisagem

          if (!!estrutura_selecionada?.value && !estruturas.find(item => item.id === estrutura_selecionada?.value && item.estruturas_grupo_id === estrutura_selecionada?.estruturas_grupo_id)) {
            projetosHibridoActions.atualizaOrCriaFileira({ tipo_estrutura: elSemEstrutura }, 0)
            showEstruturasRemovidasAlert()
            limparEstrutura = true
          }
        } else if (projetosHibridoState.fileiras.length > 1) {
          const fileirasComEstrutura = projetosHibridoState.fileiras.filter(item => item.tipo_estrutura?.value && Number(item.tipo_estrutura.value) > 0);

          if (fileirasComEstrutura.length > 0) {
            let temErro = false;

            projetosHibridoState.fileiras.forEach((fileira, index) => {
              const posicaoModulo = fileira.posicao_modulo?.value;
              const estruturaFileira = fileira.tipo_estrutura;
              const estruturas = posicaoModulo === 'retrato' ? estruturasResponse.retrato : estruturasResponse.paisagem;

              if (!!estruturaFileira?.value && !estruturas.find(item => item.id === estruturaFileira?.value && item.estruturas_grupo_id === estruturaFileira?.estruturas_grupo_id)) {
                temErro = true;
                projetosHibridoActions.atualizaOrCriaFileira({ tipo_estrutura: elSemEstrutura }, index)
              }
            })

            if (temErro) {
              showEstruturasRemovidasAlert()
              limparEstrutura = true
            }
          }
        }

        if (limparEstrutura) {
          Object.assign(savePayload, { estruturas_calculadas: [] })
          oldEstruturasHibrido$.next([]);
        }
      }
      
      projetosHibridoActions.changeValue(savePayload)
      projetosHibridoActions.syncFileiras(undefined, limparEstrutura ? elSemEstrutura : undefined, alterouQtdModulos)
    }
  }, [projetosHibridoState.tipo_bateria, projetosHibridoState.cargas_prioritarias, projetosHibridoState.fileiras, projetosHibridoState.modulo_selecionado?.componente_id, projetosHibridoState.modulo_selecionado?.quantidade, projetosHibridoState.modulos, projetosHibridoState.regioes, projetosHibridoState.tensao_saida?.id, projetosHibridoState.acessorios, projetosHibridoState.estruturas_calculadas])

  const mostrarCampoValorServico = useMemo(()=>{
    return !!(servicoObrigatorio && projetosHibridoState.recebe_servico) 
  },[servicoObrigatorio, projetosHibridoState.recebe_servico])

  const exibirJustificativaValorServico = useMemo(() => {
    if (!PermissionUtil.can(PermissionUtil.PERMISSION_PROJETOS_EDITAR_ESPECIAL_SERVICO, permissoes)) return false;
    if (!mostrarCampoValorServico) return false;
    
    if (!projetosHibridoState.valor_servico) return false;
    if (!projetosHibridoState.valor_minimo_servico) return false;

    const valorServicoProjeto = Number(projetosHibridoState.valor_servico || 0)
    return valorServicoProjeto < Number(projetosHibridoState.valor_minimo_servico || 0);
  },[mostrarCampoValorServico, permissoes, projetosHibridoState.valor_minimo_servico, projetosHibridoState.valor_servico])

  const checkError = useCallback((categoriaId: number, qtd: number): boolean => {
    if (categoriaId !== ID_CABO) {
      return false;
    }
    if (qtd === 0) {
      return false;
    }
    if (qtd % 25 === 0) {
      return false;
    }
    return true
  },[])
  
  useEffect(()=>{
    exibeJustificativaValorServico$.next(exibirJustificativaValorServico)
  },[exibirJustificativaValorServico])

  const nextButtonDisabledStatus = useMemo((): { status: boolean, tooltip: string } => {
    const validations: { tooltip: string, validationFn: () => boolean }[] = [
      {
        tooltip: projetosHibridoStoreValidationState.fileiras.helper || HIBRIDO_ERROR_MESSAGES.FILEIRAS_INVALIDAS,
        validationFn: () => {
          const estruturaFaltante = (projetosHibridoState.fileiras || []).some(item => !item.tipo_estrutura);
          const modulosFileiras = (projetosHibridoState.fileiras || []).reduce((acc, curr) => {
            return acc + (Number(curr.quantidade_modulos || 0) * Number(curr.fileiras || 0))
          }, 0)
          const qtdModulosCalculados = Number(projetosHibridoState.modulo_selecionado?.quantidade || 0);

          return !projetosHibridoStoreValidationState.fileiras.status || (modulosFileiras !== qtdModulosCalculados) || estruturaFaltante || false
        }
      },
      {
        tooltip: 'Para salvar o projeto é necessário preencher o valor do serviço.',
        validationFn: () => {
          if (servicoObrigatorio && !projetosHibridoState.valor_servico) return true;
          return false;
        }
      },
      {
        tooltip: 'Para finalizar o projeto é necessário inserir o valor mínimo do serviço',
        validationFn: () => {
          if (servicoObrigatorio && (projetosHibridoState.valor_servico || 0) > 0 && !validacaoValorServicoMinimo(projetosHibridoState.valor_servico || 0, projetosHibridoState.valor_minimo_servico, permissoes)) {
            return true;
          }
          return false;
        }
      },
      {
        tooltip: `Para finalizar o projeto é necessário inserir a justificativa do valor de serviço`,
        validationFn: () => {
          if (exibirJustificativaValorServico && !(projetosHibridoState.justificativa_valor_servico || "")) return true;
          return false;
        }
      },
      {
        tooltip: 'Não foi possível calcular os valores do projeto, preencha todos os campos obrigatórios para prosseguir.',
        validationFn: () => {
          return !projetosHibridoState.resultado_calculos
        }
      },
      {
        tooltip: 'Aguarde o calculo finalizar para prosseguir.',
        validationFn: () => {
          return calculando
        }
      },
      {
        tooltip: 'Selecione um módulo para prosseguir.',
        validationFn: () => {
          return !projetosHibridoState.modulo_selecionado
        }
      },
      {
        tooltip: `Cabo: ${MENSAGEM_QUANTIDADE_CABOS_INVALIDA}`,
        validationFn: () => {
          const cabos = projetosHibridoState.acessorios.filter(item => item.categoria_componentes_id === ID_CABO);
          if (cabos.some(cabo => checkError(cabo.categoria_componentes_id, Number(cabo.quantidade)))) {
            return true
          }
          return false;
        }
      },
    ]

    const firstError = validations.find(validation =>  validation.validationFn() )
    
    return { status: !!firstError, tooltip: firstError?.tooltip || '' }
  },[calculando, exibirJustificativaValorServico, projetosHibridoState.fileiras, projetosHibridoState.justificativa_valor_servico, projetosHibridoState.modulo_selecionado, permissoes, projetosHibridoStoreValidationState.fileiras.helper, projetosHibridoStoreValidationState.fileiras.status, projetosHibridoState.resultado_calculos, servicoObrigatorio, projetosHibridoState.valor_minimo_servico, projetosHibridoState.valor_servico, projetosHibridoState.acessorios, checkError])

  const itensSolucao = useMemo(() => {
    const categorias = categoriasComponentes?.data || [];
    const itens = [...projetosHibridoState.solucao_calculada.inversores, ...projetosHibridoState.solucao_calculada.baterias];
    return itens?.map(item => {
        const categoria = categorias?.find((i: CategoriaComponente) => i.id === item?.categoria_componentes_id);
        return {
          ...item,
          nome_categoria: categoria?.nome || "",
          grupo_categoria: categoria?.grupo || "",
          ordem_listagem: categoria?.ordem_listagem || item?.categoria_componentes_id,
        }
      })?.sort((a, b) => {
        const pesoGrupoA = ORDEM_GRUPO_CATEGORIAS[a.grupo_categoria as TGrupoCategoria] || a?.categoria_componentes_id;
        const pesoGrupoB = ORDEM_GRUPO_CATEGORIAS[b.grupo_categoria as TGrupoCategoria] || b?.categoria_componentes_id;
  
        if (pesoGrupoA !== pesoGrupoB) {
          return pesoGrupoA - pesoGrupoB;
        }
  
        return a.ordem_listagem - b.ordem_listagem;
      })
  }, [projetosHibridoState.solucao_calculada.baterias, projetosHibridoState.solucao_calculada.inversores, categoriasComponentes])

  const itensEstruturas = useMemo(() => {
    const categorias = categoriasComponentes?.data || [];
    const itens = projetosHibridoState.estruturas_calculadas || [];
    return itens?.map(item => {
        const categoria = categorias?.find((i: CategoriaComponente) => i.id === item?.categoria_componentes_id);
        return {
          ...item,
          ordem_listagem: categoria?.ordem_listagem || item?.categoria_componentes_id,
        }
      })?.sort((a, b) => a.ordem_listagem - b.ordem_listagem)
  }, [projetosHibridoState.estruturas_calculadas, categoriasComponentes])

  const itensAcessorios = useMemo(() => {
    const categorias = categoriasComponentes?.data || [];
    const itens = projetosHibridoState.acessorios || [];
    return itens?.map(item => {
        const categoria = categorias?.find((i: CategoriaComponente) => i.id === item?.categoria_componentes_id);
        return {
          ...item,
          ordem_listagem: categoria?.ordem_listagem || item?.categoria_componentes_id,
        }
      })?.sort((a, b) => a.ordem_listagem - b.ordem_listagem)
  }, [projetosHibridoState.acessorios, categoriasComponentes])

  const notSelectedModulos = useMemo(() => {
    return (projetosHibridoState.modulos || []).filter(item => item.componente_id !== projetosHibridoState.modulo_selecionado?.componente_id)
  }, [projetosHibridoState.modulo_selecionado?.componente_id, projetosHibridoState.modulos])

  if (isMobile){
    return (<>
      <Layout
        onClickBack={onClickBack}
        onClickNext={onClickNext}
        nextButtonIsDisabled={nextButtonDisabledStatus.status}
        nextButtonDisabledTooltip={nextButtonDisabledStatus.tooltip}
        title="Solução"
        nextButtonLabel="Finalizar projeto">
          <SolucaoMobile handleOpenModalEstruturas={()=>setModalEditarEstruturasOpen(true)} handleChangeModulo={(moduloId: number)=>onChangeModulo(moduloId)}/>
          {modalEditarEstruturasOpen && <ModalEditarEstruturas open={modalEditarEstruturasOpen} onClose={() => setModalEditarEstruturasOpen(false)} />}
          <ServicoInformationModal formState={{ valor_servico: projetosHibridoState.valor_servico, valor_servico_pis_cofins: projetosHibridoState.valor_servico_pis_cofins } as any} />
      </Layout>
    </>)
  }
  return (
    <Layout
      onClickBack={onClickBack}
      onClickNext={onClickNext}
      nextButtonIsDisabled={nextButtonDisabledStatus.status}
      nextButtonDisabledTooltip={nextButtonDisabledStatus.tooltip}
      title="Solução"
      nextButtonLabel="Finalizar projeto"
    >
      <Box p={2}>
        <Table aria-label="listagem de modulos disponíveis">
          <TableHead>
            <TableRow>
              {temPermissaoCodigoComponente && <TableCell style={{ width: "126px" }} align='left'><strong>Código</strong></TableCell>}
              <TableCell align='left'><strong>Produtos</strong></TableCell>
              <TableCell style={{ width: "220px" }} align='center'><strong>Quantidade</strong></TableCell>
              <TableCell style={{ width: "200px" }} align='center'><strong>Dados Técnicos</strong></TableCell>
              <TableCell style={{ width: "200px" }}  align='center' />
            </TableRow>
          </TableHead>
        </Table>

        <Collapse key={'key'} className={classes.collapseContainer} in={collapseOpened} collapsedSize={"100px"} style={{ marginBottom: 0 }}>
          <TableContainer>
            <Table aria-label="listagem de modulos disponíveis">
              <TableRow style={{ cursor: 'pointer' }} onClick={() => setCollapseOpened(old => !old)}>
                {temPermissaoCodigoComponente && <CodigoCell>
                  <span>{projetosHibridoState.modulo_selecionado?.componente_id || ''}</span>
                </CodigoCell>}
                <ProdutoCell>
                  <Box display='flex'>
                    <RadioGroup
                      row
                      aria-labelledby="demo-radio-buttons-group-label"
                      value={projetosHibridoState.modulo_selecionado?.componente_id || ''}
                      name="radio-buttons-group"
                      onChange={(e: any) => {}}
                    >
                      <FormControlLabel disabled value={projetosHibridoState.modulo_selecionado?.componente_id} control={<Radio style={{color: "green"}}/>} label="" />
                    </RadioGroup>
                    <Box textAlign={'left'}>
                      <Typography variant='body1' color='textPrimary'>
                        <strong>{projetosHibridoState.modulo_selecionado?.nome}</strong>
                      </Typography>
                      <Typography variant='body2' color='textSecondary'>
                        <span className={classes.warningText}><strong>Informações:</strong></span> {projetosHibridoState.modulo_selecionado?.descricao}
                      </Typography>
                    </Box>
                  </Box>
                </ProdutoCell>
                <QuantidadeCell>
                  <Box width="180px">
                    <InputQuantidade value={projetosHibridoState.modulo_selecionado?.quantidade || 0} highlightField={false} onChange={() => {}} disabled={true} />
                  </Box>
                </QuantidadeCell>
                  <DadosTecnicosCell componente={{ componente_id: projetosHibridoState.modulo_selecionado?.componente_id || null }} />
                <EmptyCell>
                  {notSelectedModulos.length > 0 && (
                    <>
                      {collapseOpened ? <KeyboardArrowUp /> : <KeyboardArrowDown /> }
                    </>
                  )}
                </EmptyCell>
              </TableRow>
              <TableBody>
                {notSelectedModulos.map(modulo => (
                  <TableRow key={'id'}>
                      {temPermissaoCodigoComponente && (
                        <CodigoCell>
                          <span>{modulo?.componente_id || ''}</span>
                        </CodigoCell>
                      )}
                      <ProdutoCell>
                      <Box display='flex' flexDirection={'row'}>
                        <RadioGroup
                          row
                          aria-labelledby="demo-radio-buttons-group-label"
                          value={null}
                          name="radio-buttons-group"
                          onChange={(e: any) => {
                            onChangeModulo(Number(e.target.value))
                          }}
                      >
                          <FormControlLabel value={modulo.componente_id} control={<Radio style={{color: "green"}}/>} label="" />
                        </RadioGroup>
                        <Box textAlign={'left'}>
                          <Typography variant='body1' color='textPrimary'>
                            <strong>{modulo.nome}</strong>
                          </Typography>
                          <Typography variant='body2' color='textSecondary'>
                            <span className={classes.warningText}><strong>Informações:</strong></span> {modulo.descricao}
                          </Typography>
                        </Box>
                      </Box>
                    </ProdutoCell>
                    <QuantidadeCell>
                      <Box width="180px"/>
                    </QuantidadeCell>
                      <DadosTecnicosCell componente={{ componente_id: modulo?.componente_id || null }} />
                    <EmptyCell />
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Collapse>

        {itensSolucao.length > 0 && (
          <Table aria-label="listagem da solução calculada">
            <TableBody>
              {itensSolucao.map(item => (
                <TableRow>
                  {temPermissaoCodigoComponente && (
                    <CodigoCell>
                      <span>{item?.componente_id || ''}</span>
                    </CodigoCell>
                  )}
                  <ProdutoCell>
                    <Box display='flex' flexDirection={'row'}>
                      <Box textAlign={'left'}>
                        <Typography variant='body1' color='textPrimary'>
                          <strong>{item.nome}</strong>
                        </Typography>
                        <Typography variant='body2' color='textSecondary'>
                          <span className={classes.warningText}><strong>Informações:</strong></span> {item?.descricao}
                        </Typography>
                      </Box>
                    </Box>
                  </ProdutoCell>
                  <QuantidadeCell>
                    <Box width="180px" >
                      <InputQuantidade value={item.quantidade} highlightField={false} disabled={true} onChange={(v: number) => {}} />
                    </Box>
                  </QuantidadeCell>
                    <DadosTecnicosCell componente={{ componente_id: item?.componente_id || null }} />
                  <EmptyCell />
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}

        {itensEstruturas?.length > 0 && (
          <Table aria-label="listagem de estruturas calculadas">
            <TableBody>
              {itensEstruturas?.map(item => (
                <TableRow key={'id'}>
                  {temPermissaoCodigoComponente && (
                    <CodigoCell>
                      <span>{item?.componente_id || ''}</span>
                    </CodigoCell>
                  )}
                  <ProdutoCell>
                    <Box display='flex' flexDirection={'row'}>
                      <Box textAlign={'left'}>
                        <Typography variant='body1' color='textPrimary'>
                          <strong>{item.nome}</strong>
                        </Typography>
                        <Typography variant='body2' color='textSecondary'>
                          <span className={classes.warningText}><strong>Informações:</strong></span> {item?.descricao}
                        </Typography>
                      </Box>
                    </Box>
                  </ProdutoCell>
                  <QuantidadeCell>
                    <Box width="180px">
                      <InputQuantidade value={item.quantidade} highlightField={false} disabled={false} onChange={(v: number) => onChangeQuantidade(item.componente_id, v, "estruturas")} />
                    </Box>
                  </QuantidadeCell>
                    <DadosTecnicosCell componente={{ componente_id: item?.componente_id || null }} />
                  <EmptyCell />
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}

        {itensAcessorios?.length > 0 && (
          <Table aria-label="listagem de modulos disponíveis">
            <TableBody>
              {itensAcessorios?.map(item => (
                <TableRow key={'id'}>
                  {temPermissaoCodigoComponente && (
                    <CodigoCell>
                      <span>{item?.componente_id || ''}</span>
                    </CodigoCell>
                  )}
                  <ProdutoCell>
                    <Box display='flex' flexDirection={'row'}>
                      <Box textAlign={'left'}>
                        <Typography variant='body1' color='textPrimary'>
                          <strong>{item.nome}</strong>
                        </Typography>
                        <Typography variant='body2' color='textSecondary'>
                          <span className={classes.warningText}><strong>Informações:</strong></span> {item?.descricao}
                        </Typography>
                      </Box>
                    </Box>
                  </ProdutoCell>
                  <QuantidadeCell>
                    <Tooltip title={item.quantidade_minima_finame > 0 ? "A quantidade do produto não pode ser inferior a quantidade sugerida!" : ''}>
                      <Box width="180px">
                        <InputQuantidade minValue={item.quantidade_minima_finame || 0} multiple={item.categoria_componentes_id === ID_CABO ? VALOR_MULTIPLO_CABO : 1} value={item.quantidade} highlightField={false} disabled={false} onChange={(v: number) => onChangeQuantidade(item.componente_id, v, "acessorios")} hasError={checkError(item.categoria_componentes_id, item.quantidade)}/>
                        {item.categoria_componentes_id === ID_CABO && checkError(item.categoria_componentes_id, item.quantidade) && (
                          <span style={{ color: "#b91322" }}>{MENSAGEM_QUANTIDADE_CABOS_INVALIDA}</span>
                        )}
                      </Box>
                    </Tooltip>
                  </QuantidadeCell>
                    <DadosTecnicosCell componente={{ componente_id: item?.componente_id || null }} />
                  <EmptyCell />
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}

        <Box mt={4} className="row" display="flex" justifyContent={"flex-end"}>
          <Button variant="contained" onClick={() => setModalEditarEstruturasOpen(true)} className={classes.restoreButton}>Editar Estruturas</Button>
        </Box>
      </Box>

      <Box className="row X12" style={{ padding: '0 6px 0 16px', }} display="flex" justifyContent={"space-between"}>
        <div className="X6">
          <TipoPropostaInput />
        </div>
        <div className="X6">
          <ValorServicoInput servicoObrigatorio={servicoObrigatorio} />
        </div>
      </Box>
      
      {exibirJustificativaValorServico && (
        <Box className="X12" style={{ padding: "0px 16px" }} display="flex">
          <JustificativaValorServico
            formState={{ justificativa_valor_servico: projetosHibridoState.justificativa_valor_servico || "" } as any }
            setFormState={(data) => projetosHibridoActions.changeValue({ justificativa_valor_servico: data.justificativa_valor_servico })} />
        </Box>
      )}

      <ResumoProjeto />

      <ServicoInformationModal formState={{ valor_servico: projetosHibridoState.valor_servico, valor_servico_pis_cofins: projetosHibridoState.valor_servico_pis_cofins } as any} />

      {modalEditarEstruturasOpen && <ModalEditarEstruturas open={modalEditarEstruturasOpen} onClose={() => setModalEditarEstruturasOpen(false)} />}
    </Layout>
  )
}
